import { Assets } from "../Assets";
import { LevelObject } from "../LevelObject";
export class Goal extends LevelObject {
    constructor(levelMap, position) {
        super(levelMap, Assets.goal.clone(), position);
    }
    static get type() {
        return 'goal';
    }
}
